export enum ActivityType {
  OtherActivity,
  DeliveryOfPlan,
}

export interface Activity {
  EventId: number;
  Initial: string;
  Message: string | null;
  Time: string;
  UserName: string;
  ActivityName: string | null;
  ActivityType: ActivityType;
  Comment: string | null;
  IsActivity: boolean;
}

export type ActivityItem = {
  Date: string;
  DayActivity: {
    Initial: string;
    Activities: Activity[];
  }[];
};

export interface GetActivitiesDto {
  Items: ActivityItem[];
  LastEventId: number;
}

export interface CreateUserActivityDto {
  Id?: string;
  Date: string;
  ActivityType: ActivityType;
  ActivityName: string;
  Comment: string;
}

export interface CreateUserActivityParams {
  clientId: string;
  activity: CreateUserActivityDto;
}
